__turbopack_context__.v({
  "extraWide": "emailAlertsTextTooltipContent-module-scss-module__3k3zEa__extraWide",
  "row": "emailAlertsTextTooltipContent-module-scss-module__3k3zEa__row",
  "text": "emailAlertsTextTooltipContent-module-scss-module__3k3zEa__text",
  "title": "emailAlertsTextTooltipContent-module-scss-module__3k3zEa__title",
  "tooltip": "emailAlertsTextTooltipContent-module-scss-module__3k3zEa__tooltip",
  "wide": "emailAlertsTextTooltipContent-module-scss-module__3k3zEa__wide",
});
